<template>
  <div v-show="loginState == 'WX_REGISTRY'">
    <h2 class="mb-3 text-2xl font-bold enter-x">手机绑定</h2>
    <a-form :form="form" @submit="handleLogin">
      <a-form-item>
        <a-input
          placeholder="手机号码"
          v-decorator="[
            'username',
            {
              rules: [
                {
                  required: true,
                  message: '请输入手机号码',
                },
              ],
            },
          ]"
          size="large"
        ></a-input>
      </a-form-item>
      <a-form-item>
        <div class="overflow-hidden">
          <div class="float-left" style="width: calc(100% - 160px)">
            <a-input
              placeholder="验证码"
              v-decorator="[
                'captcha',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入验证码',
                    },
                  ],
                },
              ]"
              size="large"
            >
            </a-input>
          </div>
          <div class="float-right overflow-hidden">
            <a-button
              class="float-right"
              size="large"
              style="width: 150px"
              :loading="sms_loading"
              :disbled="isStart"
              @click="sendCode"
              >{{
                isStart ? `${currentCount}s后重新获取` : '获取验证码'
              }}</a-button
            >
          </div>
        </div>
      </a-form-item>
      
      <a-form-item>
        <a-button
          type="primary"
          block
          size="large"
          html-type="submit"
          :loading="login_loading"
        >
          手机绑定</a-button
        >
        <a-button class="mt-4" block size="large" @click="handleBackLogin"
          >返回</a-button
        >
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
// todo 测试微信绑定
import { mapState } from 'vuex';
import { sendSmscode } from '@/api/user';
export default {
  data() {
    return {
      login_loading: false,
      sms_loading: false,
      codetips: '获取验证码',
      form: this.$form.createForm(this, { name: 'mobile' }),
      timerId: null,
      isStart: false,
      currentCount: 60,
    };
  },
  computed: {
    ...mapState('user', ['loginState']),
  },
  methods: {
    handleBackLogin() {
      this.$store.commit('user/SET_LOGINSTATE', { state: 'PASSWORD' });
    },
    async handleLogin(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          values.type = 3;
          this.login_loading = true;
     
          try {
            const userInfo = await this.$store.dispatch('user/login', values);
            if (userInfo) {
              this.$notification.success({
                message: '登入成功',
                description: `欢迎回来: ${userInfo.name}`,
                duration: 3,
              });
            }
          } catch (error) {
            console.log(error);
            this.$error({ title: '错误提示', content: error });
          } finally {
            this.login_loading = false;
          }
        }
      });
    },
    async sendCode() {
      let mobile = this.form.getFieldValue('username');
      if (!/^1\d{10}$/.test(mobile)) {
        this.$message.error('请输入正确的手机号码');
        return;
      }
      await sendSmscode({ tel: mobile });
      this.start();
    },
    start() {
      if (this.isStart || !!this.timerId) {
        return;
      }
      this.isStart = true;
      this.timerId = setInterval(() => {
        if (this.currentCount === 1) {
          this.stop();
          this.currentCount = 60;
        } else {
          this.currentCount -= 1;
        }
      }, 1000);
    },
    stop() {
      this.isStart = false;
      this.clear();
      this.timerId = null;
    },
    clear() {
      this.timerId && window.clearInterval(this.timerId);
    },
  },
};
</script>
